let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6FSEq")).then(() => parcelRequire('h09kj'));